import React from 'react';
import './App.less';
import BasicRoute from './Router/Router'
import { ConfigProvider} from 'antd';

function App() {
  return <div className='App'>
    <ConfigProvider
      theme={{
        "token": {
          "colorPrimary": "#00622f",
          "colorInfo": "#00622f",
          lineHeight: 1
        },
        components: {
          Menu: {
            itemHeight: 40
          }
        }
      }}
    >
      <BasicRoute />
    </ConfigProvider>
  </div>
}

export default App;

